export default class UriUtils {
    constructor(url) {
        this.url = url;
    }

    addQueryParam(paramKey, paramValue) {
        if(paramValue) {
            if(this.url.indexOf("?") > -1) {
                this.url += `&${paramKey}=${paramValue}`
            } else {
                this.url += `?${paramKey}=${paramValue}`
            }
        }

        return this;
    }

    getQueryParam(param) {
        // Seems to be the best way to extract a query parameter from url
        param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        let regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
        let results = regex.exec(this.url);

        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    build() {
        return this.url;
    }
}


// WEBPACK FOOTER //
// ./js/utils/UriUtils.js